import React from "react"
import { graphql } from "gatsby"
import {
  SEO,
  BaseLayout,
  Breadcrumb,
  PageTitle,
  ImageWithLabel,
  MdxProviderWithConfig,
} from "../components"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { langId } from "../languages"
import { useFeatureStories } from "../hooks"
import classnames from "classnames"

const FeatureStoriesTemplate = props => {
  // console.log("FeatureStoriesTemplate", props)
  const post = props.data.mdx
  const {
    imagePageTitleConfig,
    title,
    description,
    keywords,
    ogImage,
  } = props.data.mdx.frontmatter
  const { baseSlug, langKey } = props.data.mdx.fields
  const { domainUrl } = props.data.site.siteMetadata
  const featureStories = useFeatureStories()
  const isLangEN = langKey === "en"
  return (
    <BaseLayout
      lang={props.pageContext.langKey}
      baseSlug={props.pageContext.baseSlug}
      hasFeatureStory
    >
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        uriPath={props.uri}
        lang={props.pageContext.langKey}
        baseSlug={baseSlug}
        ogImage={ogImage}
        script={[
          {
            type: "application/ld+json",
            innerHTML: `
            {
              "@context":"https://schema.org",
              "@type":"ItemList",
              "itemListElement":[
                {
                  "@type":"ListItem",
                  "position":1,
                  "url":"${domainUrl}/${langKey}/${featureStories[0].baseSlug}"
                },
                {
                  "@type":"ListItem",
                  "position":2,
                  "url":"${domainUrl}/${langKey}/${featureStories[1].baseSlug}"
                },
                {
                  "@type":"ListItem",
                  "position":3,
                  "url":"${domainUrl}/${langKey}/${featureStories[2].baseSlug}"
                }
              ]
            }
          `,
          },
        ]}
      ></SEO>
      <div className="feature-stories-template">
        <Breadcrumb
          className={classnames({
            "feature-stories-template__breadcrumb": true,
            "feature-stories-template__breadcrumb--en": isLangEN,
          })}
          pathArr={[
            { langKey: langId.HOME, baseSlug: "" },
            { langKey: langId.FEATURE_STORIES, baseSlug: post.fields.baseSlug },
          ]}
        ></Breadcrumb>
        <div className="feature-stories-template__content">
          <div className="feature-stories-template__content__title-container">
            <h1
              className={classnames({
                "feature-stories-template__content__title-container__title": true,
                "feature-stories-template__content__title-container__title--en": isLangEN,
              })}
              dangerouslySetInnerHTML={{
                __html: imagePageTitleConfig[0].title,
              }}
            ></h1>
            <div
              className={classnames({
                "feature-stories-template__content__title-container__image": true,
                "feature-stories-template__content__title-container__image--en": isLangEN,
              })}
            >
              <ImageWithLabel
                fluidImage={imagePageTitleConfig[0].img.childImageSharp.fluid}
                imgAlt={imagePageTitleConfig[0].imgAlt}
                imgTitle={imagePageTitleConfig[0].imgTitle}
              ></ImageWithLabel>
            </div>
          </div>
          <MdxProviderWithConfig>
            <MDXRenderer>{post.body}</MDXRenderer>
          </MdxProviderWithConfig>
        </div>
      </div>
    </BaseLayout>
  )
}

export default FeatureStoriesTemplate

export const pageQuery = graphql`
  query FeatureStoriesTemplateQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        ...MdxFrontmatterFragment
        imagePageTitleConfig {
          ...MdxFrontmatterImagePageTitleConfigFragment
        }
      }
      fields {
        baseSlug
        langKey
        slug
        urlSlug
      }
    }
    site {
      siteMetadata {
        domainUrl
      }
    }
  }
`
